import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import download from "../../../../assets/img/svg/DownloadIcon.svg";
import { Tabs, Tab, AppBar, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import del from '../../../../assets/img/svg/Del.svg'
import { useNavigate } from "react-router-dom";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import styles from "../../../../assets/jss/customStyle";
import $ from "jquery";
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import image from '../../../../assets/img/svg/Image.svg';
import Ship from "../../../../assets/img/svg/Ship.svg";
import Close from "@material-ui/icons/Close";
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import moment from "moment";
import { getSettingsFormat } from "../../../../actions/SettingsAction";
import active from '../../../../assets/img/svg/active.svg';
import deactive from '../../../../assets/img/svg/deactive.svg';
import InnerImageZoom from "react-inner-image-zoom";
import { formatRelativeWithOptions } from "date-fns/fp";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

class EditTPOY extends Component {
    constructor(props) {
        super(props)
        this.inputFile = React.createRef();
        this.state = {
            isMobile: false,
            value: 0,
            isView: false,
            ProjectId: 0,
            ActualDateError: false,
            DocsError: false,
            fileUrl: "",
            fileName: "",
            DelIndex: 0,
            filename: "",
            index: 0,
            awsname: "",
            IfdeletePost: {
                "PlannedDate": null,
                "ActualDate": null,
                "Month": "",
                "Id": 0,
                "TrainingTitle": "",
                "TrainingId": 0,
                "Modify": localStorage.getItem("UserRoles")
            },
            addData: {
                "PlannedDate": null,
                "ActualDate": null,
                "Month": "",
                "Id": 0,
                "TrainingTitle": "",
                "TrainingId": 0,
                "Comments": "",
                "Modify": ""
            },
            Docs: [],
        }
    }

    componentDidMount() {
        (localStorage.getItem("UserRoles") == "Admin" || localStorage.getItem("UserRoles") == "Supervisor") ? this.setState({ isView: false }) : this.setState({ isView: true })
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.addData.Id = parseInt(localStorage.getItem("TrainingPlanEditId"))
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.addData.Modify = localStorage.getItem("UserRoles");
        this.setState({})
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.getedittpydocinfo(this.state.addData.Id)
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#PLAN1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Trainingplan1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Trainingplan").addClass("d-none");
        $("#Trainingplan").removeClass("d-block");
        $("#TPL").removeClass("active-color");
        $("#TPT").removeClass("fw-bolder");
    }

    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        })
        if (newValue == 1) {
            this.gethistoryloginfo(this.state.ProjectId)
        }
        if (newValue == 0) {
            // this.getedittpydocinfo(this.state.addData.Id)
        }
    };

    gethistoryloginfo = (id) => {
        let apiUrl = API.HISTORY_LOG + id + '?name=TrainingPlan'
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
            // data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.dispatch({ type: "HISTORY_LOG", data: response.data });
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
    this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#PLAN1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Trainingplan1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Trainingplan").removeClass("d-none");
        $("#Trainingplan").addClass("d-block");
        $("#TPL").addClass("active-color");
        $("#TPT").addClass("fw-bolder");
    };

    AttachFiles = (e) => {
        this.inputFile.current.click();
    };

    UploadFile = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                FileSize: a.size,
                check: false,
                fdata: a,
                FileUrl: await this.toBase64(a),
            }
            this.state.Docs.push(upload)
            this.setState({})
        })
    };

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    EditCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/trainingplanofyard")
        window.$("#cancelpopup").modal("hide")
    };

    OpenCancel = () => {
        if (this.state.value == 1) {
            this.state.value = 0
            this.setState({})
            this.getedittpydocinfo(this.state.addData.Id)
        }
        else {
            if (this.state.cancel == true) {
                window.$("#cancelpopup").modal("show")
            }
            else {
                this.props.dispatch({ type: "CANCEL", data: false });
                this.props.navigate(`/trainingplanofyard`)
            }
        }
    }

    getedittpydocinfo = (id) => {
        let apiUrl = API.TRAINING_PLAN + '/id?id=' + id
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.IfdeletePost.TrainingId = response.data.TrainingId;
                    this.state.IfdeletePost.Month = response.data.Month;
                    this.setState({})
                    this.state.addData.PlannedDate = response.data.PlannedDate ? response.data.PlannedDate : null;
                    this.state.addData.ActualDate = response.data.ActualDate ? response.data.ActualDate : null;
                    this.state.addData.Month = response.data.Month;
                    this.state.addData.Id = response.data.Id;
                    this.state.addData.TrainingTitle = response.data.TrainingTitle;
                    this.state.addData.TrainingId = response.data.TrainingId;
                    this.state.addData.Comments = response.data.Comments;
                    this.setState({})
                    if (response.data?.Photo.length > 0) {
                        response.data?.Photo.map((i) => {
                            i.FileName = i.FileName;
                            i.ObjectKey = i.ObjectKey;
                            i.AwsFolderName = i.AwsFolderName;
                            i.AwsUniqueFileName = i.AwsUniqueFileName;
                            i.FileExtention = i.FileExtention;
                            i.FileUrl = i.FileUrl;
                            i.check = false;
                        })
                        this.state.Docs = response.data?.Photo;
                    }
                    this.setState({})
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    EditSave = () => {
        if (this.state.addData.ActualDate == null || this.state.addData.ActualDate == '') {
            this.state.ActualDateError = true;
            this.setState({})
        }
        else {
            this.state.ActualDateError = false;
            this.setState({})
        }
        if (this.state.Docs.length == 0) {
            this.state.DocsError = true;
            this.setState({})
        }
        else {
            this.state.DocsError = false;
            this.setState({})
        }
        if (this.state.ActualDateError !== true && this.state.DocsError !== true) {
            this.props.dispatch({ type: "CANCEL", data: false });
            let formData = new FormData()
            let array = [];
            Array.from(this.state.Docs).forEach(async (a) => {
                if (a.AwsUniqueFileName == undefined) {
                    formData.append("attachments", a.fdata)
                    array.push(a)
                }
            })
            if (this.state.addData.Comments != null) {
                this.state.addData.Comments = this.state.addData.Comments.trim();
                this.setState({})
            }
            this.addtabledocinfo(this.state.addData, formData, this.state.addData.Id, array)
        }
    }

    addtabledocinfo = (data, formData, id, array) => {
        let apiUrl = API.TRAINING_PLAN + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    if (array.length > 0) {
                        this.adduploadtabdocinfo(formData, id)
                    }
                    else {
                        this.props.dispatch({ type: "SHOW_LOADER", data: false })
                        this.props.navigate("/trainingplanofyard")
                    }
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {

                }
            });
    };

    adduploadtabdocinfo = (data, id) => {
        let apiUrl = API.TRAINING_PLAN + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (response?.status === 200) {
                    this.props.navigate("/trainingplanofyard")

                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {

                }
            });
    };

    handleInputChange = (e, str) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (str == "Comments") {
            if (e.target.value.length - 1 < 1000) {
                this.state.addData[str] = e.target.value;
                this.setState({});
            }
        }
        else {
            this.state.addData[str] = e.target.value;
            this.setState({});
        }
        this.setState({})
    }

    OpenPopup = (filename, awsname, id, index) => {
        this.state.filename = filename;
        this.state.awsname = awsname;
        // this.state.Id = id;
        this.state.DelIndex = index;
        this.setState({})
        window.$("#deletepopupfile").modal("show");
    }

    OpenActualDelete = () => {
        window.$("#deletepopupactual").modal("show");
    }

    DeleteItemActual = () => {
        window.$("#deletepopupactual").modal("hide");
        this.DeleteActualDate(this.state.addData.Id, this.state.addData.Modify)
    }

    DeleteActualDate = (id, name) => {
        let apiUrl = API.TRAINING_PLAN + '/actual/id?id=' + id + '&modify=' + name;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
            // data: data,
            // headers : {
            //   'content-type': 'application/json'
            // }
        })
            .then((response) => {
                if (response?.status === 200) {
                    let data = [];
                    data.push(this.state.IfdeletePost)
                    this.Post_Actual(data)
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    Post_Actual = (data) => {
        let apiUrl = API.TRAINING_PLAN + '/actual'
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    // this.GetTrining(this.state.ProjectId)
                    // this.Training_Month(this.state.ProjectId)
                    this.props.navigate(`/trainingplanofyard`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    DeleteItem = () => {
        let tempData = [];
        this.state.Docs.map((i, index) => {
            if (this.state.DelIndex == index) {
                if (i.AwsUniqueFileName == this.state.awsname) {
                    this.filedeletetable(this.state.addData.Id, this.state.awsname)
                }
            }
            if (this.state.DelIndex != index) {
                tempData.push(i)
            }
        })
        this.state.Docs = tempData;
        this.setState({})
        window.$("#deletepopupfile").modal("hide");
    }

    filedeletetable = (id, name) => {
        let apiUrl = API.TRAINING_PLAN + '/id?id=' + id + '&filename=' + name;
        axios({
            method: "DELETE",
            url: apiUrl,
            // data: data,
            // headers : {
            //   'content-type': 'application/json'
            // }
        })
            .then((response) => {
                if (response?.status === 200) {
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    openView = (url, name, ind) => {
        this.state.fileUrl = url;
        this.state.fileName = name;
        this.state.index = ind;
        this.setState({})
        window.$('#viewscreen').modal('show')
    }
    nextView = (ind) => {
        if (this.state.Docs.length === ind) {
            this.setState({
                index: 0
            })
        }
        else {
            this.setState({
                index: ind
            })
        }

    }
    preView = (ind) => {
        if (ind === -1) {
            this.setState({
                index: this.state.Docs.length - 1
            })
        }
        else {
            this.setState({
                index: ind
            })
        }

    }
    setIndex = (ind) => {
        this.setState({
            index: ind
        })
    }
    render() {
        let { classes, menuToggle } = this.props;
        const { isView } = this.state;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"PLAN" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="PLAN" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5 ">
                                    <h4>{isView ? "Training Plan" : "Edit Training Plan"}</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                {!isView ? <></> : <>
                                    <td width="5%" className="border-right">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                    <td></td>
                                    <td></td>
                                    <td></td></>}
                                {this.state.value == 1 ? <>
                                    <td width="5%" className="border-right">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>

                                </> : <>
                                    {isView ? <></> : <>

                                        <td className="border-right text-center">
                                            <i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                        <td className="border-right text-center">
                                            <span className={classes.button} disabled={isView ? true : false} onClick={this.EditSave} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px', opacity: isView ? '0.5' : '' }}></img>&nbsp;Save</span> </td>
                                        <td className="border-right text-center">
                                            <span className={`${classes.button}`} onClick={this.OpenCancel} style={{ minWidth: '70px' }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</span>
                                        </td>
                                        <td className=" text-center">
                                            <span className={`${classes.button}`} disabled={isView ? true : false} style={{ minWidth: '70px' }} onClick={() => { this.OpenActualDelete() }}><img src={Delete} style={{ marginTop: '-4px', opacity: isView ? '0.5' : '' }}></img>&nbsp;Delete</span>
                                        </td>
                                    </>}
                                </>}
                            </tr>
                        </tbody>
                    </table>
                        : <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                    <td width="95%">
                                        {isView ? <></> : <>
                                            {this.state.value == 0 ? <>
                                                <button className={classes.button} disabled={isView ? true : false} onClick={() => this.EditSave()}><img src={Save} style={{ marginTop: '-4px', opacity: isView ? '0.5' : '' }}></img>&nbsp;Save</button>
                                                <button className={`${classes.button} pl-3`} onClick={this.OpenCancel}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                                <button className={`${classes.button} pl-3`} disabled={isView ? true : false} onClick={() => { this.OpenActualDelete() }}><img src={Delete} style={{ marginTop: '-4px', opacity: isView ? '0.5' : '' }}></img>&nbsp;Delete</button>
                                            </> : <></>}
                                        </>}
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "0" : "5px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 mt-3 ml-2">{isView ? "Training Plan" : "Edit Training Plan"}</h6>}

                        <div className="row ">
                            <div>
                                {isView ? <></> : <>
                                    <AppBar position="static" color="inherit" className={classes.root} style={{ margin: '0', maxHeight: '0px' }}>
                                        <Tabs
                                            value={this.state.value}
                                            onChange={this.handleChange}
                                            classes={{ indicator: classes.indicator }}
                                        >
                                            <Tab className="ml-4" label="Details" style={{ textTransform: "none", minWidth: '10px' }} {...a11yProps(0)} />
                                            <Tab label="History log" style={{ textTransform: "none", minWidth: '10px' }} {...a11yProps(1)} />
                                        </Tabs>
                                    </AppBar>
                                </>}
                                <TabPanel value={this.state.value} index={0}>
                                    <div>
                                        <div className={this.state.isMobile ? isView ? "row px-0 mt-n3" : "row px-0 mt-3" : isView ? "row px-2 mt-n3" : "row px-2 mt-4"}>
                                            <div className={`row mx-0 mt-2 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2"}`}>
                                                    <label className={this.state.isMobile ? "d-flex mt-2" : "float-end text-right d-flex"}>Training Title&nbsp;:
                                                    </label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : " pb-4 col-md-4 pt-4"}`}>
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        type="text"
                                                        value={this.state.addData.TrainingTitle && this.state.addData.TrainingTitle}
                                                        disabled
                                                        InputProps={{
                                                            className: `border-radius view-color ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                </div>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? "d-flex mt-2" : "float-end text-right d-flex"}>Planned Date&nbsp;:
                                                    </label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : " pb-4 col-md-4 pt-4"}`}>
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        type="date"
                                                        disabled
                                                        id="type-date"
                                                        placeholder={this.state.addData.PlannedDate && moment(this.state.addData.PlannedDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                        InputProps={{
                                                            className: `border-radius  view-color ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                </div>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "px-0 col-md-2 mt-2"}`}>
                                                    <label className={this.state.isMobile ? "d-flex mt-2" : "float-end d-flex text-right"}>Actual Date&nbsp;:
                                                        {isView ? <></> :
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div>}
                                                    </label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "pb-4 col-md-4 pt-4"}`}>
                                                    {isView ?
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            type="date"
                                                            fullWidth
                                                            disabled
                                                            id="type-date"
                                                            value={this.state.addData.ActualDate && moment(this.state.addData.ActualDate).format("yyyy-MM-DD")}
                                                            placeholder={this.state.addData.ActualDate && moment(this.state.addData.ActualDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                            onChange={(e) => { this.handleInputChange(e, "ActualDate") }}
                                                            InputProps={{
                                                                className: `border-radius view-color ${classes.inputfieldAlign}`
                                                            }}
                                                        /> :
                                                        this.state.ActualDateError ?
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                error
                                                                id="type-date"
                                                                value={this.state.addData.ActualDate && moment(this.state.addData.ActualDate).format("yyyy-MM-DD")}
                                                                inputProps={{
                                                                    max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                                    min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                                  }}
                                                                placeholder={this.state.addData.ActualDate && moment(this.state.addData.ActualDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                                onChange={(e) => { this.handleInputChange(e, "ActualDate") }}
                                                                type="date"
                                                                // helperText="Required field must be filled in"
                                                                InputProps={{
                                                                    className: `border-radius ${classes.inputfieldAlign}`
                                                                }}
                                                                classes={{ root: classes.helperText }}
                                                            />
                                                            :
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                type="date"
                                                                fullWidth
                                                                id="type-date"
                                                                value={this.state.addData.ActualDate && moment(this.state.addData.ActualDate).format("yyyy-MM-DD")}
                                                                inputProps={{
                                                                    max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                                    min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                                  }}
                                                                placeholder={this.state.addData.ActualDate && moment(this.state.addData.ActualDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                                onChange={(e) => { this.handleInputChange(e, "ActualDate") }}
                                                                InputProps={{
                                                                    className: `border-radius ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                    }
                                                </div>
                                            </div>
                                            <div className={`row mx-0  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                                    <label className={this.state.isMobile ? "d-flex mt-2" : "float-end d-flex text-right pt-4"}>Photos&nbsp;:
                                                        {isView ? <></> :
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div>}
                                                    </label>
                                                </div>
                                                {isView ? <>
                                                    <div
                                className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 align-items-center ${
                                  this.state.isMobile
                                    ? "border-left border-right border-bottom"
                                    : "pb-1 col-md-10"
                                }`}
                              >
                                <div className="row px-1">
                                  {this.state.Docs && this.state.Docs.map((i, ind) => (
                                      <div
                                        className={`col-12 col-sm-6 col-lg-6 col-xl-4 col-md-6 align-items-center px-1 mt-2 mb-2 ${
                                          window.innerWidth < 410
                                            ? "col-12"
                                            : this.state.isMobile
                                            ? "col-md-4 "
                                            : "col-md-6"
                                        }`}
                                      >
                                        <div className="row d-flex">
                                          <div
                                            className={`${
                                              window.innerWidth < 290
                                                ? ""
                                                : "col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3"
                                            }`}
                                            onClick={() => {
                                              this.openView1(
                                                i.FileUrl,
                                                i.FileName,
                                                ind
                                              );
                                            }}
                                          >
                                            <img
                                              className="cursorPointer"
                                              width={
                                                window.innerWidth < 290
                                                  ? "100%"
                                                  : "257px"
                                              }
                                              src={i.FileUrl}
                                              onClick={() => {
                                                this.openView1(
                                                  i.FileUrl,
                                                  i.FileName,
                                                  ind
                                                );
                                              }}
                                              style={{
                                                height: "201px",
                                                marginTop: "-9px",
                                                objectPosition: "50% 50%",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </div>
                                                    {/* <div className={`col-12 col-sm-12 col-lg-10 col-xl-11 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom" : "pt-3 pb-2 col-md-10"}`}>
                                                        <div className="row px-2">
                                                            {this.state.Docs && this.state.Docs.map((i, ind) => (
                                                                <div className={`col-6 col-sm-4 col-lg-3 col-xl-2 align-items-center border-right px-1 mb-2 ${window.innerWidth < 410 ? "col-12" : this.state.isMobile ? "col-md-4 " : "col-md-4"}`}>
                                                                    <div className="row d-flex">
                                                                        <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3" onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }}>
                                                                            <img className="cursorPointer" src={i.FileUrl} onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                                        </div>
                                                                        <div className="col-10 col-sm-10 col-lg-10 col-xl-10 col-md-10">
                                                                            <div className="cursorPointer pt-2 ml-3 overflow" onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }}>{i.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div> */}
                                                </> : <>
                                                    <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>

                                                        {this.state.DocsError ?
                                                            <TextField
                                                                error
                                                                variant="outlined"
                                                                size="small"
                                                                accept=".png,.jpg"
                                                                onChange={(e) => this.UploadFile(e)}
                                                                style={{ borderColor: 'red' }}
                                                                fullWidth
                                                                placeholder="Browse File"
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment style={{ marginRight: 0 }}>
                                                                            <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                                                <AttachFileIcon />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                                }}
                                                            /> : <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                disabled
                                                                accept=".png,.jpg"
                                                                onChange={(e) => this.UploadFile(e)}
                                                                placeholder="Browse File"
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment className="mr-0">
                                                                            <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                                                <AttachFileIcon />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                    className: `border-radius ${classes.inputfieldAlign}`
                                                                }} />}
                                                        <input
                                                            type="file"
                                                            hidden
                                                            accept=".png,.jpg"
                                                            onChange={(e) => this.UploadFile(e)}
                                                            ref={this.inputFile}
                                                        />
                                                    </div>
                                                    <div className="col-12 col-sm-12 col-lg-6 col-xl-8"></div>
                          <div className="row mx-0 px-0">
                            <div
                              className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 align-items-center ${
                                this.state.isMobile
                                  ? "border-left border-right border-bottom col-md-12"
                                  : "mt-2"
                              }`}
                            >
                              <div
                                className={
                                  this.state.isMobile
                                    ? "row pl-2 pr-3"
                                    : "row px-1"
                                }
                              >
                                {this.state.Docs &&
                                  this.state.Docs.map((i, ind) => (
                                    <div
                                      className={`col-12 col-sm-6 col-lg-6 col-xl-4 col-md-6 align-items-center px-1 mt-2 mb-2 ${
                                        window.innerWidth < 410
                                          ? "col-12"
                                          : this.state.isMobile
                                          ? "col-md-4 "
                                          : "col-md-6"
                                      }`}
                                    >
                                      <div className="row d-flex">
                                        <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9"></div>
                                        <div className="col-3 col-sm-3 col-lg-3 col-xl-3 col-md-3">
                                          <img
                                            src={Delete}
                                            className="cursorPointer"
                                            onClick={() => { this.OpenPopup(i.FileName, i.AwsUniqueFileName, i.Id, ind) }}
                                          />
                                        </div>
                                        <div
                                          className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 px-2 pt-3"
                                          onClick={() => {
                                            this.openView(
                                              i.FileUrl,
                                              i.FileName,
                                              ind
                                            );
                                          }}
                                        >
                                          <img
                                            className="cursorPointer"
                                            width={
                                              window.innerWidth < 290
                                                ? "100%"
                                                : "257px"
                                            }
                                            src={i.FileUrl}
                                            onClick={() => {
                                              this.openView(
                                                i.FileUrl,
                                                i.FileName,
                                                ind
                                              );
                                            }}
                                            style={{
                                              height: "201px",
                                              marginTop: "-9px",
                                              objectPosition: "50% 50%",
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                                                    {/* <div className={`col-12 col-sm-12 col-md-12 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                                        <div className={this.state.isMobile ? "row pl-2 pr-3" : "row px-1"}>
                                                            {this.state.Docs && this.state.Docs.map((i, ind) => (
                                                                <div className={`col-6 col-sm-4 col-lg-6 col-xl-3 align-items-center border-right  px-1 mt-1 mb-2 ${window.innerWidth < 410 ? "col-12" : this.state.isMobile ? "col-md-4 " : "col-md-6"}`}>
                                                                    <div className="row d-flex">
                                                                        <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3" onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }}>
                                                                            <img className="cursorPointer" src={i.FileUrl} onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                                        </div>
                                                                        <div className="col-8 col-sm-8 col-lg-8 col-xl-8 col-md-8">
                                                                            <div onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }} className="cursorPointer pt-2 ml-3 overflow">{i.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                                        </div>
                                                                        <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pl-1 pr-2 mt-2 pt-2">
                                                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(i.FileName, i.AwsUniqueFileName, i.Id, ind) }} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div> */}
                                                </>}
                                            </div>
                                            <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-n4 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? "mt-2" : "float-end text-right"}>Comments&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-10 col-xl-11   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                    <TextField
                                                        multiline
                                                        rows={8}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        disabled={isView ? true : false}
                                                        value={this.state.addData.Comments}
                                                        onChange={(e) => { this.handleInputChange(e, "Comments") }}
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign} ${isView ? "view-color" : ""} `
                                                        }}
                                                    />
                                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.Comments?.length}/1000 Characters left</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel value={this.state.value} index={1}>
                                    <div className="row">
                                        <div className="mt-3 pt-3">
                                            <div className="col-sm-12 col-12 px-0">
                                                <div className="table-responsive mb-4" style={{ width: "100%" }}>
                                                    <table id="dataTable" className="table">
                                                        <thead>
                                                            <tr className="">
                                                                <th className="border-top border-right border-left" style={{ width: '15%', minWidth: '160px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Timestamp</span></th>
                                                                <th className="border-top border-right" style={{ width: '10%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                                                <th className="border-top border-right" style={{ width: '15%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Action by</span></th>
                                                                <th className="border-top border-right" style={{ width: '60%', minWidth: window.innerWidth < 1000 ? '400px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Comments</span></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody style={{ fontFamily: 'Segoe UI' }}>
                                                            {this.props.historyLog && this.props.historyLog.map((i) => (
                                                                <tr>
                                                                    <td className="spandoc-td border-right border-left align-middle Nowrap">
                                                                        {moment(i.TimeStamp).format(this.props.settings.Convention ? this.props.settings.Convention + " hh:mm:ss A" : "DD/MM/YYYY hh:mm:ss A")}
                                                                    </td>
                                                                    <td className="spandoc-td border-right align-middle">{i.Action}</td>
                                                                    <td className="spandoc-td border-right align-middle">{i.ActionBy}</td>
                                                                    <td className="spandoc-td border-right align-middle">{i.Comments}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                            </div>
                        </div >
                    </div >
                    <div class="modal fade " id="viewscreen" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: this.state.isMobile ? "25%" : "13%", left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "", overflowY: 'scroll', height: "90vh" }}>
                        <div class="modal-dialog modal-lg " role="document">
                            <div class="modal-content ">
                                <div class="modal-body pt-0 pb-2 pr-0 pl-0 ">
                                    <div className="row">
                                        <div className="col-12 ">
                                            <div className='cursorPointer float-end mr-3' id="viewscreen" onClick={() => {
                                                window.$('#viewscreen').modal('hide')

                                            }} >
                                                <button className={`${classes.button} px-0 hidefield`} >&nbsp;Close</button>
                                            </div>
                                        </div>
                                        <div className='col-12 text-center'>
                                            <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel" style={{}} >
                                                <div class="carousel-indicators">

                                                </div>
                                                <div class="carousel-inner" >
                                                    {this.state.Docs && this.state.Docs.map((i, ind) => (<>
                                                        <div class={ind === this.state.index ? "carousel-item active col-12 text-center align-middle" : " align-middle carousel-item col-12 text-center"}>
                                                            <div>
                                                                <InnerImageZoom
                                                                    moveType="drag"
                                                                    zoomScale={2}
                                                                    hideCloseButton={true}
                                                                    src={i.FileUrl}
                                                                    hasSpacer={true}
                                                                    afterZoomIn={() => { $('#viewscreen > div > div ').addClass('Transparent'); $('.hidefield').removeClass('d-block'); $('.hidefield').addClass('d-none'); }}
                                                                    afterZoomOut={() => { $('#viewscreen > div > div ').removeClass('Transparent'); $('.hidefield').addClass('d-block'); $('.hidefield').removeClass('d-none'); }}
                                                                />
                                                            </div>
                                                            {this.state.Docs.length <= 1 ? "" : <>
                                                            <button class="carousel-control-prev my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.preView(ind - 1)} data-bs-slide="prev">
                                                                <span class="carousel-control-prev-icon black" aria-hidden="true"></span>
                                                                <span class="visually-hidden">Previous</span>
                                                            </button>
                                                            <button class="carousel-control-next  my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.nextView(ind + 1)} data-bs-slide="next">
                                                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                                <span class="visually-hidden">Next</span>
                                                            </button>
                                                            </>}
                                                        </div>
                                                    </>))}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopupfile" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>

                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>

                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => { this.DeleteItem() }}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => { window.$("#deletepopupfile").modal("hide"); }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopupactual" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>

                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>

                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => { this.DeleteItemActual() }}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => { window.$("#deletepopupactual").modal("hide"); }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.EditCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => { window.$("#cancelpopup").modal("hide") }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
        historyLog: state.commonReducer.historyLog || [],
    };
}

EditTPOY.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditTPOY))
);
